'use strict';

(function(){
    angular
        .module('commons')
        .component('paginationDisplayWidget',{
            templateUrl :  'commons/components/pagination-display-widget.tpl.html',
            controller : function($timeout,$scope){
                var vm  = this;
                vm.startPosition = "";

                vm.onKeyPress = function (evt) {
                    var charCode = (evt.which) ? evt.which : event.keyCode
                    var tmp;
                    if (charCode > 31 && (charCode < 48 || charCode > 57)){
                        evt.preventDefault();
                        evt.stopPropagation();
                        return false;
                    }else{
                        tmp = parseInt(evt.target.value + String.fromCharCode(charCode));
                        if(typeof tmp == 'number' && tmp <= vm.totalNumberOfRecords){
                            return true;
                        }else{
                            evt.preventDefault();
                            evt.stopPropagation();
                            return false;
                        }
                    }
                };
                
                vm.onChange = function (d) {
                    if(vm.startPosition <= 0){
                        vm.startPosition = 1;
                    }
                    vm.onStartPositionChange({params: vm.startPosition});
                };

                vm.onClick = function () {
                    vm.startPosition = "";
                }

            },
            bindings : {
                totalNumberOfRecords : '<',
                availableRecordsLength : '<',
                pageSize : '<',
                onStartPositionChange : '&'
            }
        });
})();
